export const TIME_SLOTS_FETCH_DAYS_RANGE = 400;

export const MY_DOCS = 'MyDoctors';

export const COVID_CARE = 'covid-care';

export const WIV_VISIT_TYPE_IDS = ['16642242987', '19213770041'];

export const WCC_VISIT_TYPE_IDS = ['6464077157'];

export const WCE_VISIT_TYPE_IDS = ['9787047555'];

export const DOC_PHONE_COLORS = {
  st0: '#F5F5F5',
  st1: 'clip-path:url(#SVGID_2_)',
  st2: '#B3B3B3',
  st3: '#292929',
  st4: '#4C4C4C',
  st5: '#919191',
  st6: '#CCCCCC',
  st7: '#E5E5E5',
  st8: '#2A2A2A',
  st9: '#2E2E2E',
  st10: '#C6C6C6',
  st11: '#999999',
  st12: '#949494',
  st13: '#2C2C2C',
  st14: '#808080',
  st15: '#DCDCDC',
  st16: '#EEEEEE',
  st17: '#BFBFBF',
  st18: 'none;stroke:#CCCCCC;stroke-width:3;stroke-miterlimit:10s'
};

export const COVID_COLORS_HOSPITAL = {
  st0: '#F5F5F5',
  st2: '#CCCCCC',
  st3: '#EDEDED',
  st4: '#979797',
  st5: '#B6B6B6',
  st6: '#4A4A4A',
  st7: '#FFFFFF',
  st8: '#A1A1A1',
  st9: '#C0C0C0',
  st10: '#343434',
  st11: '#F8F8F8',
  st12: '#004394'
};

export const COVID_COLORS_MASK = {
  st0: '#D8D8D8',
  st1: '#C8C8C8',
  st2: '#E7E7E7',
  st3: '#ECECEC',
  st4: '#303030',
  st5: '#808080',
  st6: '#353535',
  st7: '#3E3E3E',
  st8: '#494949',
  st9: '#383838',
  st10: '#444444',
  st11: '#323232',
  st12: '#373737',
  st13: '#535353',
  st14: '#4E4E4E',
  st15: '#3A3A3A',
  st16: '#4D4D4D',
  st17: '#3D3D3D',
  st18: '#3F3F3F',
  st19: '#393939',
  st20: '#646464',
  st21: '#848484',
  st22: '#969696',
  st23: '#959595',
  st24: '#D2D2D2',
  st25: '#9B9B9B',
  st26: '#B8B8B8',
  st27: '#B5B5B5',
  st28: '#F6F6F6',
  st29: '#3B3B3B',
  st30: '#4C4C4C',
  st31: '#3C3C3C',
  st32: '#030303',
  st33: '#FAFAFA',
  st34: '#4F4F4F',
  st35: '#F9F9F9',
  st36: '#505050',
  st37: '#E1E1E1',
  st38: '#434343',
  st39: '#090909',
  st40: '#454545',
  st41: '#727272',
  st42: '#040404',
  st43: '#6E6E6E',
  st44: '#FFFFFF',
  st45: '#004394'
};
